import * as yup from 'yup';

export function validateGsheetIntegration(data) {
  const schema = yup.object().shape({
    spreadsheetUrl: yup.string().required(),
    spreadsheetId: yup.string().required(),
    sheetId: yup.string().required(),
    accessToken: yup.string().required(),
    refreshToken: yup.string().required(),
  });
  return schema.isValidSync(data);
}

export function validateCustomScriptIntegration(data) {
  const schema = yup.object().shape({
    content: yup.string().required(),
  });
  return schema.isValidSync(data);
}

export function validateWebhookIntegration(data) {
  const schema = yup.object().shape({
    url: yup.string().required(),
  });
  return schema.isValidSync(data);
}

export function validateGoogleAnalyticsIntegration(data) {
  const schema = yup.object().shape({
    analyticsId: yup.string().required(),
  });
  return schema.isValidSync(data);
}

export function validatePixelAnalyticsIntegration(data) {
  const schema = yup.object().shape({
    analyticsId: yup.string().required(),
  });
  return schema.isValidSync(data);
}
